import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { Field } from 'bloomer/lib/elements/Form/Field/Field';
import { Label } from 'bloomer/lib/elements/Form/Label';
import { Control } from 'bloomer/lib/elements/Form/Control';
import { Input } from 'bloomer/lib/elements/Form/Input';
import { Select } from 'bloomer/lib/elements/Form/Select';
import api from '../util/api';
import { confirmSuccessAfter } from '../util/helperFunctions';
import { Button } from 'bloomer/lib/elements/Button';

interface PropTypes {
  isOpen: boolean;
  handleClose: () => void;
  refresh?: () => void;
}

const AddLocationModal = ({ isOpen, handleClose, refresh }: PropTypes) => {
  const [name, setName] = useState('');
  const [bioSecurity, setBioSecurity] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setName('');
    setBioSecurity(1);
    setIsLoading(false);
  }, [isOpen]);

  const handleNameChange = (e: React.FormEvent<HTMLInputElement>) =>
    setName((e.target as HTMLInputElement).value);

  const handleBioSecurityChange = (e: React.FormEvent<HTMLInputElement>) =>
    setBioSecurity(parseInt((e.target as HTMLInputElement).value, 10));

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    await confirmSuccessAfter('Location added successfully!', () =>
      api.locations.post({
        name,
        bioSecurity,
      })
    );
    setIsLoading(false);
    handleClose();
    if (refresh) {
      refresh();
    }
  };
  return (
    <Modal header="Add Location" isOpen={isOpen} handleClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <Field>
          <Label htmlFor="name">Location Name</Label>
          <Control>
            <Input
              id="name"
              name="name"
              type="text"
              value={name}
              onChange={handleNameChange}
              required={true}
              disabled={isLoading}
            />
          </Control>
        </Field>
        <Field>
          <Label htmlFor="bioSecurity">Bio Security Level</Label>
          <Control>
            <Select
              id="bioSecurity"
              name="bioSecurity"
              type="text"
              value={bioSecurity}
              onChange={handleBioSecurityChange}
              required={true}
              disabled={isLoading}
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
            </Select>
          </Control>
        </Field>
        <Field>
          <Label htmlFor="bioSecurity">Bio Security Level</Label>
          <Control>
            <Button
              isLoading={isLoading}
              disabled={isLoading}
              isColor="primary"
              type="submit"
            >
              Submit
            </Button>
          </Control>
        </Field>
      </form>
    </Modal>
  );
};

export default AddLocationModal;
